import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Registered once, on <main> (see application.html.erb), rather than on each individual
// screenshot: a single delegated click listener catches every current and future <img> matching
// either of the two conventions every real screenshot in this app already uses (a help-doc
// screenshot's own classes, or any <img> inside a .browser-chrome wrapper on a marketing page),
// so none of the 70+ image_tag calls across help/home/features/integrations/languages views need
// to change. Anything else (avatars, logos, language icons) matches neither selector and stays
// inert.
//
// One shared modal (see the "lightbox" partial rendered once in application.html.erb) rather than
// a modal per screenshot: only ever one image enlarged at a time, so reusing a single
// Modal instance and swapping its <img src> is simpler than instantiating dozens of them, almost
// all of which would never be opened in a given visit.
export default class extends Controller {
  static targets = ["image"]

  connect() {
    this.modal = Modal.getOrCreateInstance("#lightbox")
    this.element.addEventListener("click", this.handleClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick)
  }

  handleClick = (event) => {
    const image = event.target.closest("img.img-fluid.rounded.shadow-sm, .browser-chrome img")
    if (!image) return

    this.imageTarget.src = image.src
    this.imageTarget.alt = image.alt
    this.modal.show()
  }
}
